import React from "react";
import { GetMoneyValue } from "../../../../../Api/ApiCommon";
import { PayInfoDetailProps } from "../PayInfoDetail";
import {
  PayDetailItem,
  PayDetailItemChildText,
  PayDetailItemGrayText,
  PayDetailItemText,
} from "./PartyFeePay";
import { getLPointShowValue } from "../../../../../ApiTS/ApiCommonTS";

export default function PartyEndRewBreak({ data }: PayInfoDetailProps) {
  return (
    <>
      {/* label */}
      <PayDetailItem>
        {data?.log?.fowner > 0 && (
          <PayDetailItemText>중도 해산 보상금</PayDetailItemText>
        )}

        <PayDetailItemText>잔여 파티 요금 환급</PayDetailItemText>
        <>
          <PayDetailItemChildText>파티 분담금</PayDetailItemChildText>
          <PayDetailItemChildText>링키드 수수료</PayDetailItemChildText>
        </>

        {data?.log?.reward - data?.log?.fowner > 0 && (
          <PayDetailItemText>추가 적립 혜택</PayDetailItemText>
        )}

        <PayDetailItemText>파티 보증금 환급</PayDetailItemText>

        {data?.log?.coupon > 0 && (
          <PayDetailItemText>쿠폰 혜택</PayDetailItemText>
        )}

        {data?.log?.point > 0 && (
          <PayDetailItemText>링키드 포인트 사용</PayDetailItemText>
        )}

          {data?.log?.pg != null && data?.log?.pg > 0 && (
          <PayDetailItemText>PG 환불</PayDetailItemText>
        )}
      </PayDetailItem>

      {/* value */}
      <PayDetailItem>
        {/* 중도 해산 보상금 */}
        {data?.log?.fowner > 0 && (
          <PayDetailItemText>
            {GetMoneyValue(data?.log?.fowner)}
          </PayDetailItemText>
        )}

        {/* 잔여 파티 요금 환급 */}
        <PayDetailItemText>
          {GetMoneyValue(data?.log?.returnfee)}
        </PayDetailItemText>

        <>
          {/* 파티 분담금 */}
          <PayDetailItemGrayText>
            {GetMoneyValue(data?.log?.returnfee - data?.log?.comm)}
          </PayDetailItemGrayText>
          {/* 링키드 수수료 */}
          <PayDetailItemGrayText>
            {GetMoneyValue(data?.log?.comm)}
          </PayDetailItemGrayText>
        </>

        {/* 추가 적립 혜택 */}
        {data?.log?.reward - data?.log?.fowner > 0 && (
          <PayDetailItemText>
            {GetMoneyValue(data?.log?.reward - data?.log?.fowner)}
          </PayDetailItemText>
        )}

        {/* 파티 보증금 환급 */}
        <PayDetailItemText>
          {GetMoneyValue(data?.log?.deposit)}
        </PayDetailItemText>

        {/* 쿠폰 혜택 */}
        {data?.log?.coupon > 0 && (
          <PayDetailItemText>
            -{GetMoneyValue(data?.log?.coupon)}
          </PayDetailItemText>
        )}

        {data?.log?.point > 0 && (
          <PayDetailItemText>
            -{getLPointShowValue(data?.log?.point)}
          </PayDetailItemText>
        )}



        {data?.log?.pg != null && data?.log?.pg > 0 && (
          <PayDetailItemText>
            -{GetMoneyValue(data?.log?.pg)}
          </PayDetailItemText>
        )}
      </PayDetailItem>
    </>
  );
}
